import React, {useState, useContext, useEffect} from 'react';
import styled from 'styled-components';
import BodyKnowledgeDescription from '../BodyKnowledgeDescription';
import {DocumentTypeIdContext} from '../../../../Main/Forms/CanvasFormContainer';
import {createRequestURL, createUpdatePayloadForMultiSelectBody} from '../Common/BodyResponseUtility';
import {formBodyType} from '../../../../../util/uiconstants';
import RadioButton from '../../../BaseComponentWrappers/MotifRadio';
import RiskFactorContainer from '../Common/RiskFactorContainer';
import {labels, GetCardTypeForBody} from '../../../../../util/utils';
import ProgressBar from '../../../BaseComponentWrappers/MotifProgressBar';
import _ from 'lodash';
import {useDocumentId, useEngagementId} from '../../../../../util/customHooks';

export default function SingleSelectTitle(props) {
	const {
		isAresView,
		showGuidance,
		guidanceFilter,
		options,
		headerId,
		sectionId,
		bodyId,
		updateBodyOptions,
		getBodiesBySectionId,
		isSnapshotView,
		isSaving,
		setIsSaving
	} = props;

	const engagementId = useEngagementId(),
		documentId = useDocumentId(),
		documentTypeId = useContext(DocumentTypeIdContext),
		[changedResponse, setChangedResponse] = useState(false),
		[singleSelectTitleData, setSingleSelectTitleData] = useState([]);

	const formBodyBorder = GetCardTypeForBody(options, isAresView);

	const sectionClick = (evt) => {
		evt.preventDefault();
		toggleClick(evt);
	};

	const toggleClick = (e) => {
		if (props.isSnapshotView || isSaving) {
			e.preventDefault();
			return;
		}
		const changed = e.currentTarget.id;
		setIsSaving(true);

		document.getElementById(bodyId).classList.add('greyOutArea');

		if (singleSelectTitleData && singleSelectTitleData.length > 0) {
			singleSelectTitleData.map((data) => {
				if (data.bodyOptionId === data.bodySelectedOptionId && data.bodyOptionId !== Number(changed)) {
					data.isChecked = !data.isChecked;
				} else if (data.bodyOptionId === Number(changed)) {
					data.isChecked = !data.isChecked;
				}
			});
			setSingleSelectTitleData(singleSelectTitleData);
			setChangedResponse(!changedResponse);
		}

		const bodyResponseObject = createUpdatePayloadForMultiSelectBody(
			formBodyType.SingleSelectTitle,
			singleSelectTitleData
		);
		updateBodyOptions(
			bodyId,
			changed,
			createRequestURL(engagementId, documentId, headerId, sectionId, bodyId, documentTypeId),
			bodyResponseObject
		);
	};

	useEffect(() => {
		let bodyData = _.cloneDeep(options.optionsAndResponses);

		if (bodyData && bodyData.length > 0) {
			let filterBodyData = bodyData.map((obj) => ({
				...obj,
				isChecked: isSnapshotView ? obj.bodySelectedOptionId : obj.bodyOptionId === obj.bodySelectedOptionId
			}));
			setSingleSelectTitleData(filterBodyData);
		} else {
			setSingleSelectTitleData([]);
		}
	}, [options.optionsAndResponses, isSnapshotView]);

	return (
		<Wrapper className={`SectionBodyWrapper ${formBodyBorder}`}>
			{options && (
				<BodyKnowledgeDescription
					isAresView={isAresView}
					showGuidance={showGuidance}
					guidanceFilter={guidanceFilter}
					cardType={formBodyBorder}
					isSnapshotView={isSnapshotView}
					bodyModel={options}
					engagementId={engagementId}
					documentId={documentId}
					headerId={headerId}
					sectionId={sectionId}
					bodyId={bodyId}
					bodyDescriptionText={options.name}
					isCustom={options.isCustom}
					isDuplicate={options.isDuplicate}
					getBodiesBySectionId={getBodiesBySectionId}
				/>
			)}
			<section className="SectionBodyData SingleSelectTileBodyData" id={bodyId}>
				<section className="MotifProgressBarWrapper">
					<ProgressBar isIndeterminate showLabel labelComponent={<span>{labels.saving}</span>} />
				</section>
				<section className="SingleSelectTileBody">
					{!isSnapshotView ? (
						<>
							{singleSelectTitleData &&
								singleSelectTitleData.map((data) => {
									return (
										/*<section
											className={`section-radio ${data.isChecked ? 'checked' : ''}`}
											id={!isSnapshotView && data.bodyOptionId}
											onClick={sectionClick}
										>*/
										<RadioButton
											id={!isSnapshotView && data.bodyOptionId}
											radioId={data.bodyOptionId}
											radioName={data.id}
											isChecked={data.isChecked}
											labelValue={data.bodyOptionText}
											title={data.bodyOptionText}
											onClick={toggleClick}
											disabled={isSnapshotView}
											noOfLines={2}
										/>
										/*</section>*/
									);
								})}
						</>
					) : (
						<>
							{singleSelectTitleData &&
								singleSelectTitleData.map((data) => {
									return (
										/*<section className={`section-radio ${data.isChecked ? 'checked' : ''}`}>*/
										<RadioButton
											id={!isSnapshotView && data.bodyOptionId}
											radioId={data.bodyOptionId}
											radioName={data.id}
											isChecked={data.isChecked}
											labelValue={data.bodyOptionText}
											title={data.bodyOptionText}
											onClick={toggleClick}
											disabled={isSnapshotView}
											noOfLines={2}
										/>
										/*</section>*/
									);
								})}
						</>
					)}
				</section>
				{singleSelectTitleData &&
					singleSelectTitleData.map((data) => {
						return (
							data.isChecked &&
							data.riskFactorList.length > 0 && (
								<RiskFactorContainer
									riskFactors={data.riskFactorList}
									isVisible
									sectionId={sectionId}
									bodyId={bodyId}
									isViewBodyOnly={false}
								/>
							)
						);
					})}
			</section>
		</Wrapper>
	);
}

const Wrapper = styled.section`
	display: block;
	.motif-tooltip-wrapper {
		width: calc(100% - var(--px-30));
	}
	.SectionBodyData {
		display: flex !important;
		flex-wrap: wrap;
		width: 100%;
		position: relative;
		.MotifProgressBarWrapper {
			display: none;
			position: absolute;
			justify-content: center;
			width: 80%;
			height: 100%;
			.motif-progress-bar-wrapper {
				height: 100%;
				width: 30%;
				width: 30%;
				z-index: 1;
				justify-content: center;
				span {
					color: var(--green-500);
					font-size: var(--px-12);
				}
				.motif-progress {
					background-color: var(--green-500);
				}
			}
		}
		&.greyOutArea {
			.RiskFactorContainer {
				.MotifProgressBarWrapper {
					display: none !important;
				}
			}
		}
		.SingleSelectTileBody {
			display: flex;
			flex-direction: column;
			flex-wrap: wrap;
			width: 100%;
		}
		.section-radio {
			width: var(--px-300) !important;
			margin: var(--px-15) var(--px-20) var(--px-15) 0;
			height: var(--px-78) !important;
			display: flex;
			cursor: pointer;
		}
	}
`;
